import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

export default function Create() {

  const { auditorId } = useParams();
  const [swal, setSwal] = useAlert();

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState(null);
  const handleChangeEmployee = ({target: { value, name }}) => {
    setSelectedEmployee(value);
    setSelectedEmployeeName(name);
  };

  const [selectedStatus, setSelectedStatus] = useState(null);
  const handleChangeStatus = ({target: { value, name }}) => setSelectedStatus(value);

  const [employees, setEmployees] = useState([]);
  const fetchEmployee = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}employees`, {
        params: { all: true }
      });

      setEmployees(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleCreate= async () => {};
  const handleUpdate= async () => {};

  useEffect(() => {

    fetchEmployee();

  }, []);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Auditor
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
          {auditorId ? `Edit` : `Create`}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{auditorId ? `Edit` : `New`} Auditee Form</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Employee ID</Form.Label>
                      <Typeahead
                        id="employee-selector"
                        labelKey={(option) => option.EMP_NAME}
                        options={employees}
                        selected={employees.filter((a) => a.EMP_ID === selectedEmployee)}
                        onChange={(selected) => {
                          setSelectedEmployee(selected.length > 0 ? selected[0].EMP_ID : null);
                        }}
                        placeholder="Please Select..."
                      />
                      {/* <Form.Control as="select"
                        value={selectedEmployee ?? -1}
                        onChange={handleChangeEmployee}
                      >
                        <option value={-1}>Select ID</option>
                        {employees && employees.map((employee, key) => (
                          <option key={key}value={employee.EMP_ID}>
                            {employee.EMP_NAME}
                          </option>
                        ))}
                      </Form.Control> */}
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        enabled='false'
                        name="name"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Control as="select"
                        value={selectedStatus ?? -1}
                        onChange={handleChangeStatus}
                      >
                        <option value={-1}>Select Status...</option>
                        <option value='Active'>Active</option>
                        <option value='InActive'>InActive</option>

                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{ justifyContent: 'flex-end' }}>
          <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
            {auditorId
              ? (<><Button onClick={handleUpdate} variant="success">Update</Button>{' '}</>)
              : (<><Button onClick={handleCreate} variant="primary">Create</Button>{' '}</>)
            }
          </Col>
        </Row>
      </Container>
    </>
  );
};

